export default __webpack_public_path__ + "static/media/victoronto.05edf409.jpg";